export default "__VITE_ASSET__8885d76a__"